// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1":"c8f2b26e","27":"f52c734d","142":"edf7bd48","301":"3726bb21","406":"c160eed9","802":"8452df6e"}[chunkId] + ".chunk.css";
};